import React from "react";
import GenericList from "../../components/lists/GenericList";
import { listAudioTranscriptions } from "../../actions/audio-transcription/listAudioTranscriptions";

const AudioTranscriptionList: React.FC<{
  refresh: boolean;
  onRefreshComplete: () => void;
}> = ({ refresh, onRefreshComplete }) => {
  return (
    <GenericList
      fetchData={listAudioTranscriptions}
      refresh={refresh}
      onRefreshComplete={onRefreshComplete}
      selectable
    />
  );
};

export default AudioTranscriptionList;
